import NextHead from 'next/head'
import React, { FunctionComponent } from 'react'
import { useIsDarkMode } from '@afterpaytouch/core'

export interface HeadProps {
  title: string
  setMobileStatusBarColor?: string
}

export const Head: FunctionComponent<HeadProps> = ({ title, setMobileStatusBarColor }) => {
  const isDarkMode = useIsDarkMode()
  const defaultColor = isDarkMode ? '#000000' : '#FFFFFF'
  const themeColor = setMobileStatusBarColor ?? defaultColor

  return (
    <NextHead>
      <title>{title}</title>
      <meta property='og:title' content={title} />
      <meta name='viewport' content='initial-scale=1.0, width=device-width, maximum-scale=1.0, user-scalable=no' key='viewport' />
      <meta name='theme-color' content={themeColor} />
    </NextHead>
  )
}
